import { useQuery } from '@tanstack/react-query';
import { officeMessages } from '@/utils/api';

export function useMessages(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['messages', params],
    queryFn: () => officeMessages.getAll(params).then((r) => r.data),
  });
}

export function useUnreadCount() {
  return useQuery({
    queryKey: ['messages', 'unread-count'],
    queryFn: () => officeMessages.getUnreadCount().then((r) => r.data),
    refetchInterval: 30000,
  });
}
